import { isPredefinedSectionSlug } from '../workout/predefined-sections'
import { SectionPage } from '../workout/section-page'
import React from 'react'
import { Navigate, useParams } from 'react-router-dom'

export const AllWorkoutsBySectionScreen = (): React.ReactElement => {
  const { sectionId } = useParams<{ sectionId: string }>()

  if (isPredefinedSectionSlug(sectionId)) {
    return <SectionPage slug={sectionId} />
  }

  // Only the four predefined slugs are linked anywhere in the app. Anything else (e.g. a stale
  // bookmark to a retired WorkoutSection id) redirects home rather than rendering a dead screen.
  return <Navigate to="/workouts" replace />
}
